<template>
  <transition name="fade">
    <div class="promptMsg" :class="`hook-${hook}`" v-show="showPrompt">{{ msg }}</div>
  </transition>
</template>

<script>
export default {
  props: {
    hook: {
      type: String,
      default: 'vh'
    }
  },
  data() {
    return {
      showPrompt: false,
      msg: ''
    }
  },
  methods: {
    setMsg(msg) {
      this.msg = msg
      this.showPrompt = true
      setTimeout(() => {
        this.showPrompt = false
        this.msg = ''
      }, 1500)
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.promptMsg {
  padding: get_vh(10px) get_vh(30px);
  background-color: rgba(31, 31, 31, 0.8);
  border-radius: get_vh(48px);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  color: #fff;
  text-align: center;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: get_vh(20px);
  white-space: nowrap;

  &.hook-px {
    padding: 10px 30px;
    border-radius: 48px;
    font-size: 20px;
  }
}
</style>